/**
 * The ONE Azure Storage secret redactor (ruling F4), process-agnostic so main (`storageErrors.ts` re-exports it for every
 * log line, error message, session file, pin payload, transfer manifest and analytics property) and the renderer (the
 * Transfers drawer's copied error report — F9, integration review 2026-09-26) apply the same rule.
 *
 * Redacts SECRETS, never identifiers (review m7): the whole query string of a URL, and `sig=` / `AccountKey=` /
 * `SharedAccessSignature=` pairs where they stand as a token — at the start, after whitespace or after a `?`, `&`, `;`
 * or quote. A path segment such as `exports/AccountKey=2026.csv` is a name and stays intact (the `/` before the key
 * excludes it).
 */
export function redactStorageSecrets(text: string): string {
  return text
    .replace(/(https?:\/\/[^\s"'<>?]+)\?[^\s"'<>]*/g, '$1?<redacted>')
    .replace(/(^|[\s?&;"'(,])(sig|AccountKey|SharedAccessSignature)=[^;&\s"'<>]*/gi, (_m, lead: string, key: string) =>
      `${lead}${/^sig$/i.test(key) ? 'sig' : key}=<redacted>`,
    );
}
